import { CreateDepositDto, Deposit, PointsBalance, Session } from 'types/api.types';
import { apiService } from './apiService';

export const getCurrentSession = async () => {
  try {
    return await apiService.get<Session>('/deposits/session/active');
  } catch (error) {
    return null;
  }
};

export const startSession = async () => {
  try {
    return await apiService.post<Session>('/deposits/session/start', {});
  } catch (error) {
    return null;
  }
};

export const endSession = async (id: string) => {
  try {
    return await apiService.put<Session>(`/deposits/session/end/${id}`, {});
  } catch (error) {
    return null;
  }
};

export const createDeposit = async (data: CreateDepositDto, file: File) => {
  try {
    const formData = new FormData();

    if (file) {
      formData.append('image', file);
    }
    formData.append('data', JSON.stringify(data));

    console.log(formData);
    return await apiService.post<Deposit>(`/deposits`, formData, {}, true);
  } catch (error) {
    return null;
  }
};

export const deleteDeposit = async (id: number) => {
  try {
    return await apiService.post<{ id: string }>(`/deposits/delete/${id}`, {});
  } catch (error) {
    return null;
  }
};

export const getCurrentDeposits = async (): Promise<Deposit[]> => {
  try {
    return await apiService.get<Deposit[]>('/deposits/current');
  } catch (error) {
    return [];
  }
};

export const getSubmittedDeposits = async (): Promise<Deposit[]> => {
  try {
    return await apiService.get<Deposit[]>(`/deposits/submitted`, {});
  } catch (error) {
    return [];
  }
};

export const getPoints = async (): Promise<PointsBalance> => {
  try {
    return await apiService.get<PointsBalance>(`/deposits/points`, {});
  } catch (error) {
    return {
      currentPoints: 0,
      pendingPoints: 0,
    };
  }
};
